/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { TenantService } from '@src/app/shared/tenant.service';
import { DateHelper } from "@src/app/shared/dateHelper";
import { UnreadChart } from "@src/app/modules/agent/agent-dashboard-page/UnreadChart";
import { ActionPageNavRoute } from '@src/app/routes/action-page-nav';

export class OverdueActionsChart extends UnreadChart {
    dataUrl = TenantService.ajaxPath + 'agent/dashboard/overdueActions';
    title = "My Overdue Actions";

    getSubTitle() {
        return super.getSubTitle($localize`Actions planned to complete on or before today`);
    }

    clickEvent() {

        const today = DateHelper.isoDate();
        const url = ActionPageNavRoute.getListRouteName();
        const params = { ownedById: this.dataUserId, completedAt: '', plannedDate: '<=' + today };

        this.router.navigate([url, params]);            

    }
}
